import "../settings.css";
import SideBar from "../Components/SideBar/SideBar";
import ThemeToggle from "../../../../../../Components/UI/ThemeToggle/ThemeToggle";
import { useThemeMode } from "../../../../../../theme/ThemeModeContext";
import { FiGlobe, FiSun } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../../../../../../Components/LanguageSwitch/LanguageSwitch";

function AppearanceSettings() {
  const { mode, resolvedTheme } = useThemeMode();
  const { t } = useTranslation();

  return (
    <div className="parent_wraper">
      <SideBar active="4_0" />

      <div className="dash_table_wrapper">
        <div className="flex items-center justify-between px-1 mb-6">
          <h2 className="text-lg font-semibold text-ui-text m-0">
            {t("appearance.title")}
          </h2>
        </div>

        <div className="bg-ui-surface border border-ui-border rounded-xl p-4 max-w-md">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
              <FiSun size={14} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ui-text m-0">
              {t("appearance.theme")}
            </p>
          </div>

          <label className="block text-xs font-medium text-ui-text-muted mb-1.5">
            {t("appearance.themeHint")}
          </label>

          <ThemeToggle />

          <p className="mt-3 mb-0 text-xs text-ui-text-subtle">
            {mode === "system"
              ? t("appearance.followingDevice", {
                  theme: t(`theme.${resolvedTheme}`),
                })
              : t("appearance.savedToAccount")}
          </p>
        </div>

        <div className="bg-ui-surface border border-ui-border rounded-xl p-4 max-w-md mt-4">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
              <FiGlobe size={14} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ui-text m-0">
              {t("language.label")}
            </p>
          </div>

          <label className="block text-xs font-medium text-ui-text-muted mb-1.5">
            {t("appearance.languageHint")}
          </label>

          <LanguageSwitch />

          <p className="mt-3 mb-0 text-xs text-ui-text-subtle">
            {t("appearance.languageSaved")}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AppearanceSettings;
